import React, { useState, useEffect, useRef } from "react";
import Navbarsticky from "./NavbarSticky";
import { Col, Row, Form, Card, Container } from "react-bootstrap";
import Footer from "./Footer";
import { useDispatch } from "react-redux";
import { Link, useNavigate } from "react-router-dom";

// img
import img1 from "../assets/img/hoteldetails-img3.png";
import img2 from "../assets/img/hoteldetails-img4.png";

import { getsearchsuggestion } from "../store/slices/hotel";
import Travelfeedback from "./Travelfeedback";

export default function Hotels() {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  //  refs
  const dropdownRef = useRef(null);

  const getTodayLocal = () => {
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    return today.toLocaleDateString("en-CA"); // yyyy-mm-dd
  };

  const today = getTodayLocal();

  // input  state
  const [city, setCity] = useState("");
  const [suggestions, setSuggestions] = useState([]);

  const [dropdownVisible, setDropdownVisible] = useState(false);
  const [isEditing, setIsEditing] = useState(false);
  const [selectedOption, setSelectedOption] = useState(null);
  const [error, setError] = useState("");

  const [checkInDate, setCheckInDate] = useState("");
  const [checkOutDate, setCheckOutDate] = useState("");

  const [rooms, setRooms] = useState([{ adults: 2, children: 0 }]);
  const [isRoomGuestOpen, setIsRoomGuestOpen] = useState(false);

  // date validation state
  const [dateError, setDateError] = useState(""); // shown under checkout
  const [isDateInvalid, setIsDateInvalid] = useState(false); // used to hide list & block API

  //  parse yyyy-mm-dd into UTC date (year,month-1,day)
  const parseDateToUTC = (isoDateString) => {
    if (!isoDateString) return null;
    const parts = isoDateString.split("-");
    if (parts.length !== 3) return null;
    const y = Number(parts[0]);
    const m = Number(parts[1]);
    const d = Number(parts[2]);
    if (isNaN(y) || isNaN(m) || isNaN(d)) return null;
    return Date.UTC(y, m - 1, d);
  };
  const validateDates = () => {
    setDateError("");
    setIsDateInvalid(false);

    if (!checkInDate || !checkOutDate) {
      return true;
    }

    const inUtc = parseDateToUTC(checkInDate);
    const outUtc = parseDateToUTC(checkOutDate);
    if (inUtc === null || outUtc === null) {
      setDateError("Select another date");
      setIsDateInvalid(true);
      return false;
    }

    if (outUtc <= inUtc) {
      setDateError("Check-out date must be after check-in date");
      setIsDateInvalid(true);
      return false;
    }

    setDateError("");
    setIsDateInvalid(false);
    return true;
  };
  const fetchSearchSuggestions = async (text) => {
    if (!text || text.trim().length < 2) {
      setSuggestions([]);
      return;
    }

    try {
      const res = await dispatch(
        getsearchsuggestion({ search: text })
      ).unwrap();

      setSuggestions(res || []);
    } catch (err) {
      console.error("Search suggestion error:", err);
    }
  };

  const totalGuests = rooms.reduce((sum, r) => sum + r.adults + r.children, 0);

  // add room
  const addRoom = () => {
    setRooms([...rooms, { adults: 2, children: 0 }]);
  };

  // remove room
  const removeRoom = (index) => {
    const updated = rooms.filter((_, i) => i !== index);
    setRooms(updated);
  };

  // inc / dec adult / children
  const updateRoomCount = (index, type, action) => {
    const updated = rooms.map((room, i) => {
      if (i === index) {
        return {
          ...room,
          [type]:
            action === "inc" ? room[type] + 1 : Math.max(0, room[type] - 1),
        };
      }
      return room;
    });
    setRooms(updated);
  };

  // toggle dropdown
  const toggleRoomDropdown = () => {
    setIsRoomGuestOpen(!isRoomGuestOpen);
  };

  useEffect(() => {
    const handleOutsideClick = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        const isValidOption = suggestions.some(
          (s) => s.label.toLowerCase() === city.toLowerCase()
        );

        if (!isValidOption) {
          setCity("");
          setSelectedOption(null);
        } else {
          setError("");
        }

        setDropdownVisible(false);
      }
    };

    document.addEventListener("mousedown", handleOutsideClick);
    return () => {
      document.removeEventListener("mousedown", handleOutsideClick);
    };
  }, [city, suggestions]);

  // validate dates on change of date inputs and clear errors if fixed
  useEffect(() => {
    validateDates();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [checkInDate, checkOutDate]);

  const handleOptionClick = (option) => {
    setSelectedOption(option);
    setCity(option.name);
    setIsEditing(false);
    setDropdownVisible(false);
    setError("");
  };

  const hotelPackages = [
    {
      id: 1,
      slug: "andaman-beach-stay",
      packageName: "Andaman Beach Stay",
      images: [
        {
          mediaLink: img1,
        },
      ],
      places: [
        { name: "Port Blair" },
        { name: "Havelock Island" },
        { name: "Neil Island" },
      ],
    },
    {
      id: 2,
      slug: "luxury-resort-andaman",
      packageName: "Luxury Resort Experience",
      images: [
        {
          mediaLink: img2,
        },
      ],
      places: [{ name: "Havelock Island" }, { name: "Radhanagar Beach" }],
    },
    {
      id: 3,
      slug: "budget-hotel-andaman",
      packageName: "Budget Friendly Hotels",
      images: [
        {
          mediaLink: img1,
        },
      ],
      places: [{ name: "Port Blair" }],
    },
    {
      id: 4,
      slug: "honeymoon-hotel-package",
      packageName: "Honeymoon Hotel Package",
      images: [
        {
          mediaLink: img2,
        },
      ],
      places: [
        { name: "Neil Island" },
        { name: "Havelock Island" },
        { name: "Ross Island" },
      ],
    },
  ];

  const hotelhandleSearch = () => {
    if (!selectedOption || !selectedOption._id) {
      setError("Please select a destination");
      return;
    }

    if (!checkInDate || !checkOutDate) {
      setError("Please select check-in and check-out dates");
      return;
    }

    if (!validateDates()) return;

    const params = new URLSearchParams({
      checkIn: checkInDate,
      checkOut: checkOutDate,
      rooms: String(rooms.length),
      guests: String(totalGuests),
    });

    params.append("id", selectedOption._id);
    params.append("name", selectedOption.name);
    params.append("type", selectedOption.type);

    navigate(`/hotellist?${params.toString()}`);
  };

  return (
    <>
      <Navbarsticky />
      <div className="hlx-hero-wrapper">
        <div className="hlx-container" style={{ height: "280px" }}>
          <h1 style={{ color: "white" }}>Hotel</h1>
        </div>

        <Container
          className="hlx-content-section  shadow-sm  mb-5"
          style={{
            marginBottom: "2rem",
            marginTop: "-2.5rem",
            borderRadius: "20px",
            padding: "10px",
          }}
        >
          <div className="hlx-input">
            <div className="hlx-form filter-box p-4 flex-row">
              <Form.Group className="mb-3 mx-1" ref={dropdownRef}>
                <Form.Label className="filter-label">
                  Location or Hotel Name
                </Form.Label>

                <div className="input-with-icon">
                  <input
                    type="text"
                    className="filter-input"
                    value={isEditing ? city : selectedOption?.name || ""}
                    placeholder="Location or Hotel Name"
                    onChange={(e) => {
                      const value = e.target.value;
                      setCity(value);
                      setIsEditing(true);
                      setDropdownVisible(true);
                      setError("");
                      fetchSearchSuggestions(value); // 🔥 REQUIRED
                    }}
                    onClick={() => {
                      setIsEditing(true);
                      setDropdownVisible(true);
                    }}
                  />
                  <i className="bi bi-geo-alt" />
                </div>
                {dropdownVisible && (
                  <ul
                    style={{
                      listStyleType: "none",
                      padding: 0,
                      margin: "5px 0",
                      border: "1px solid #ccc",
                      borderRadius: "4px",
                      maxHeight: "200px",
                      overflowY: "auto",
                      position: "absolute",
                      width: "260px",
                      backgroundColor: "#fff",
                      zIndex: 1000,
                    }}
                  >
                    {selectedOption && (
                      <>
                        <li
                          style={{
                            padding: "5px",
                            fontWeight: "bold",
                            backgroundColor: "#f0f0f0",
                            borderBottom: "1px solid #ccc",
                          }}
                        >
                          Recently Selected
                        </li>
                        <li
                          onClick={() => handleOptionClick(selectedOption)}
                          style={{ padding: "5px", cursor: "pointer" }}
                        >
                          {selectedOption.name}
                        </li>
                      </>
                    )}

                    {suggestions.map((option) => (
                      <li
                        key={option.id}
                        onClick={() =>
                          handleOptionClick({
                            _id: option.id,
                            name: option.label,
                            type: option.type, // 🔥 IMPORTANT
                          })
                        }
                        style={{
                          padding: "6px",
                          cursor: "pointer",
                          display: "flex",
                          gap: "6px",
                          alignItems: "center",
                        }}
                      >
                        {option.type === "place" ? "📍" : "🏨"} {option.label}
                      </li>
                    ))}
                  </ul>
                )}

                {error && (
                  <p
                    style={{ color: "red", marginTop: "5px", fontSize: "12px" }}
                  >
                    {error}
                  </p>
                )}
              </Form.Group>

              <Form.Group className="mb-3 mx-1">
                <Form.Label className="filter-label">Check In</Form.Label>
                <div className="input-with-icon">
                  <input
                    type="date"
                    className="filter-input"
                    value={checkInDate}
                    min={today}
                    onKeyDown={(e) => e.preventDefault()}
                    onChange={(e) => {
                      setCheckInDate(e.target.value);
                      setCheckOutDate("");
                    }}
                  />
                </div>
              </Form.Group>

              <Form.Group className="mb-3 mx-1">
                <Form.Label className="filter-label">Check Out</Form.Label>
                <div className="input-with-icon">
                  <input
                    type="date"
                    className="filter-input"
                    value={checkOutDate}
                    min={checkInDate || today}
                    disabled={!checkInDate}
                    onChange={(e) => setCheckOutDate(e.target.value)}
                  />
                </div>

                {dateError && (
                  <p
                    style={{ color: "red", marginTop: "5px", fontSize: "12px" }}
                  >
                    {dateError}
                  </p>
                )}
              </Form.Group>

              <Form.Group className="mb-3 mx-1 rgx-wrapper">
                <Form.Label className="filter-label">Room / Guest</Form.Label>

                <div className="rgx-input" onClick={toggleRoomDropdown}>
                  <input
                    readOnly
                    className="filter-input"
                    value={`${rooms.length} Room${
                      rooms.length > 1 ? "s" : ""
                    }, ${totalGuests} Guest${totalGuests > 1 ? "s" : ""}`}
                  />
                  <i className="bi bi-people rgx-icon" />
                </div>

                {isRoomGuestOpen && (
                  <div className="rgx-dropdown">
                    {rooms.map((room, index) => (
                      <div className="rgx-box" key={index}>
                        <h6 className="rgx-title">Room {index + 1}</h6>

                        <div className="rgx-row">
                          <span>Adult (Above 12yrs)</span>
                          <div className="rgx-counter">
                            <button
                              onClick={() =>
                                updateRoomCount(index, "adults", "dec")
                              }
                            >
                              -
                            </button>
                            <span>{room.adults}</span>
                            <button
                              onClick={() =>
                                updateRoomCount(index, "adults", "inc")
                              }
                            >
                              +
                            </button>
                          </div>
                        </div>

                        <div className="rgx-row">
                          <span>Child (Below 12yrs)</span>
                          <div className="rgx-counter">
                            <button
                              onClick={() =>
                                updateRoomCount(index, "children", "dec")
                              }
                            >
                              -
                            </button>
                            <span>{room.children}</span>
                            <button
                              onClick={() =>
                                updateRoomCount(index, "children", "inc")
                              }
                            >
                              +
                            </button>
                          </div>
                        </div>

                        {rooms.length > 1 && (
                          <button
                            className="rgx-remove"
                            onClick={() => removeRoom(index)}
                          >
                            Remove Room
                          </button>
                        )}
                      </div>
                    ))}

                    <div className="rgx-footer">
                      <button className="rgx-add" onClick={addRoom}>
                        + Add Room
                      </button>
                      <button className="rgx-done" onClick={toggleRoomDropdown}>
                        Done
                      </button>
                    </div>
                  </div>
                )}
              </Form.Group>

              <div style={{ display: "flex", gap: "8px", marginTop: "1.8rem" }}>
                <button
                  className="btn search-btn w-100"
                  onClick={hotelhandleSearch}
                >
                  Search&nbsp;
                  <i className="bi bi-search" />
                </button>
              </div>
            </div>
          </div>
        </Container>
      </div>
      <div>
        <br />
        <br />
        <br />
        <section className="tour-packages-section pt-3 mt-5 pb-1 container-fluid">
          <Container style={{ marginBottom: "5rem", marginTop: "2rem" }}>
            <div className="text-center mb-4">
              <h2 className="mt-3 new-font">Popular Hotels</h2>
              <h2 className="fw-bold mb-4">Find Your Perfect Stay</h2>

              <Row className="g-2 g-lg-4 mt-2">
                {hotelPackages.map((tour) => (
                  <Col xs={6} sm={6} md={6} lg={4} xl={3} key={tour.id}>
                    <Link to={`/hotel-package-details/${tour.slug}`}>
                      <Card className="tour-card shadow-sm border-0">
                        <div className="tour-image-wrapper">
                          <img
                            src={tour.images[0]?.mediaLink}
                            className="tour-img"
                            alt={tour.packageName}
                          />
                        </div>

                        <Card.Body>
                          <p className="pkg-title">{tour.packageName}</p>

                          <Card.Text className="text-muted text-start">
                            <i className="bi bi-geo-alt-fill text-primary me-1"></i>
                            {(() => {
                              const placeNames =
                                tour.places?.map((p) => p.name) || [];
                              const firstTwo = placeNames
                                .slice(0, 2)
                                .join(", ");
                              const rest =
                                placeNames.length > 2
                                  ? ` + ${placeNames.length - 2} more places`
                                  : "";
                              return firstTwo + rest;
                            })()}
                          </Card.Text>
                        </Card.Body>
                      </Card>
                    </Link>
                  </Col>
                ))}
              </Row>
            </div>
          </Container>
        </section>
      </div>

      <Travelfeedback />
      <Footer />
    </>
  );
}
